import { mapState } from 'pinia'
import { useRootStore } from '@/store/pinia/root'

const blackList = ['CyPageTabs']

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      computed: {
        ...mapState(useRootStore, {
          cyMixinAppearance: (state) => state.appearance,
        }),
        /** Override in a page component to provide a dynamic title instead of the i18n lookup. */
        cyMixinPageTitle () {
          return undefined
        },
      },
      watch: {
        cyMixinAppearance: {
          handler () {
            const { name: componentName = '' } = this.$options
            const isPage = componentName.startsWith('CyPage') && !blackList.includes(componentName)
            if (isPage) {
              this._updateBrowserTabTitle()
            }
          },
          immediate: true,
          deep: true,
        },
        cyMixinPageTitle (value) {
          if (value !== undefined) this._updateBrowserTabTitle()
        },
      },
      methods: {
        _updateBrowserTabTitle () {
          const { cyMixinAppearance: appearance } = this
          /** @type {import('vue-i18n').VueI18nTranslation} */
          const f = this.t ?? this.$t
          const compositeKey = `title.${this.$route.name}`
          const i18nTitle = this.cyMixinPageTitle !== undefined
            ? this.cyMixinPageTitle
            : f(compositeKey, {}, { default: f('title', {}, { default: '' }) })
          document.title = this.$showFeature.whiteLabel && appearance
            ? `${i18nTitle} | ${appearance.tab_title}`
            : `${i18nTitle} | Cycloid`
        },
      },
    })
  },
}
